import Vue from 'vue'
import { injectDtMomentIntoJquery } from '@/libs/datetime-moment'
import jQuery from 'jquery' // Import jQuery if not globally available

Vue.use({
  install() {
    // Add a global method to Vue
    Vue.$injectDtMomentIntoJquery = Vue.prototype.$injectDtMomentIntoJquery = (
      jquery = jQuery
    ) => {
      injectDtMomentIntoJquery(jquery)
    }
  },
})
